import React from 'react';

interface Step {
  number: string;
  title: string;
  description: string;
}

interface RoofingProcessProps {
  title?: string;
  subtitle?: string;
  steps?: Step[];
}

export const RoofingProcess: React.FC<RoofingProcessProps> = ({
  title = 'Our Professional Roofing Installation Process',
  subtitle = 'FROM INSPECTION TO WARRANTY',
  steps = []
}) => {
  return (
    <section className="nai-roofing-process">
      <div className="container">
        <div className="nai-section-header">
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>
        <div className="nai-process-steps">
          {steps.map((step, index) => (
            <div key={index} className="nai-process-step">
              <div className="nai-process-step__number">{step.number}</div>
              <h3 className="nai-process-step__title">{step.title}</h3>
              <p className="nai-process-step__description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};